import { Modal } from '../../helpers/commonUi';
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { Http } from "../../helpers/axois";
import { useToast } from "../../helpers/commonFunction";
import style from "./navigation.module.sass";
import { ReactComponent as Import } from "../../assets/svg/MarketplaceFunctions/Vector.svg";
import { SoloChatRoutes } from "./SoloChatRoutes";
import { onDrop } from "../apps/forms/formBuilder/helpers";
import { JourneyIcon } from '../../assets/app-modules/journeyIcon';
import { ServicesIcon } from '../../assets/app-modules/servicesIcon';
import { AIAgentIcon } from '../../assets/app-modules/aiAgenticon';
import { FormIcon } from '../../assets/app-modules/formIcon';
import { FunctionIcon } from '../../assets/app-modules/functionIcon';
import { InternationalizationIcon } from '../../assets/app-modules/internationalizationIcon';
import { StaticAssetsIcon } from '../../assets/app-modules/static-assetsIcon';
import { DataIcon } from '../../assets/app-modules/dataIcon';
import { DataModelIcon } from '../../assets/app-modules/dataModelIcon';
import { SecureVariablesIcon } from '../../assets/app-modules/secureVariablesIcon';
import { ConfigIcon } from '../../assets/app-modules/configIcon';
import { DeployIcon } from '../../assets/app-modules/deployIcon';
import { DmnIcon } from '../../assets/app-modules/dmnIcon';
import { ACLIcon } from '../../assets/app-modules/aclIcon';
const AppsMenu = () => {
  let tabs: any[] = [];
  let securityTabs: any[] = [];
  const APP_DOWNLOAD_MODAL_TITLE = "Download App";
  const APP_DOWNLOAD_MODAL_TEXT =
    "Are you sure you want to download App and all its components?";
  const pathname = useLocation().pathname;
  const locationSplit = pathname.split("/");
  const location = locationSplit[1];
  let tabLocation: any;
  tabLocation = locationSplit[5];
  const currentState: any = useSelector((state) => {
    return state;
  });
  const selectedApp: any =
    currentState && currentState.apps && currentState.apps.selectedApp;
  let journeyRedirectpath =
    selectedApp.type === "a8flow" ? "journey/assist/list" : "journey/solo/list";
  let serviceRedirectPath =
    selectedApp.type === "a8flow" ? "assist/service/list" : "solo/service/list";
  let formRedirectPath =
    selectedApp.type === "a8flow" ? "assist/forms/list" : "solo/forms/list";
  let functionRedirectPath =
    selectedApp.type === "a8flow"
      ? "assist/functions/list"
      : "solo/functions/list";
  let configurationRedirectPath =
    selectedApp.type === "a8flow"
      ? "assist/configuration/list"
      : "solo/configuration/list";
  let i18nRedirectPath =
      selectedApp.type === "a8flow"
        ? "assist/i18n/list"
        : "solo/i18n/list";
  let aiAgentPath = 
    selectedApp.type === "a8flow" ? "assist/ai-agents/workFlowAgents" : "solo/ai-agents/workFlowAgents"
  let deployRedirectPath =
    selectedApp.type === "a8flow" ? "assist/deploy/list" : "solo/deploy/list";
  let dataRedirectPath =
    selectedApp.type === "a8flow" ? "assist/data/list" : "solo/data/list";
  const staticAssetPath = selectedApp.type === "a8flow" ? "assist/static-asset/list" : "solo/static-asset/list"
  let secureVariableRedirectPath =  
    selectedApp.type === "a8flow" ? "assist/security/secure-variables/list" : "solo/security/secure-variables/list";
  let dataModelRedirectPath = selectedApp.type === "a8flow" ? "assist/dataModel/list" : "solo/dataModel/list";
  

  const { SuccessToast, ErrorToast, WarningToast } = useToast();
  const history: any = useHistory();
  const [appDownloadModalVisibility, setAppDownloadModalVisibility] =
    useState<boolean>(false);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [securityTabOpen, setSecurityTabOpen] = React.useState(tabLocation === "security");  
  const getAppId: any = matchPath(pathname, {
    path: "/apps/list/:appId/",
    exact: false,
    strict: false,
  });

  const currentOrganizationId = useSelector((state: any) => {
    return state.org.selectedOrg.id;
  });

  const currentAppBranch = useSelector((state: any) => {
    const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
    return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
  }, (left: any, right: any) => left.branchId === right.branchId)

  const appId = getAppId && getAppId.params && getAppId.params.appId;
  if (selectedApp.type === "a8solo" || selectedApp.type === "a8chat") {
    tabs = [
      {
        type: "Group",
        name: "Workflow"
      },
      {
        _id: "journey",
        name: "Journey",
        location: selectedApp.type === "a8flow" ? "assist" : "solo",
        redirectTo: journeyRedirectpath,
        icon: JourneyIcon  
      },
      {
        _id: "services",
        name: "Services",
        location: "service",
        redirectTo: serviceRedirectPath,
        icon: ServicesIcon
      },
      {
        type: "Group",
        name: ""
      },
      {
        _id: "ai-agents",
        name: "AI Agents",
        location: "ai-agents",
        redirectTo: aiAgentPath,
        style: {
          background: "linear-gradient(90deg, #42A0FF 0%, #B56BFF 33.33%, #FF7F56 99.99%, rgba(255, 178, 82, 0) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: 600
        },
        icon: AIAgentIcon
      },
      {
        type: "Group",
        name: "Conversation",
        location: "conversation",
        _id: "chat_group"
      },
      {
        type: "Group",
        name: "UI & Logic"
      },
      {
        _id: "forms",
        name: "Forms",
        location: "forms",
        redirectTo: formRedirectPath,
        icon: FormIcon
      },
      {
        _id: "functions",
        name: "Functions",
        location: "functions",
        redirectTo: functionRedirectPath,
        icon: FunctionIcon
      },
      {
        _id: "i18n",
        name: "i18n",
        location: "i18n",
        redirectTo: i18nRedirectPath,
        icon: InternationalizationIcon
      },
      {
        _id: "staticAsset",
        name: "Static Asset",
        location: "static-asset",
        redirectTo: staticAssetPath,
        icon: StaticAssetsIcon
      },
      {
        type: "Group",
        name: "Data & Security"
      },
      {
        _id: "data",
        name: "Data",
        location: "data",
        redirectTo: dataRedirectPath,
        icon: DataIcon
      },
      {
        _id: "dataModel",
        name: "Data Model",
        location: "dataModel",
        redirectTo: dataModelRedirectPath,
        icon: DataModelIcon
      },
      {
        _id: "secureVariables",
        name: "Secure Variables",
        location: "secure-variables",
        redirectTo: secureVariableRedirectPath,
        icon: SecureVariablesIcon
      },
      {
        type: "Group",
        name: "Deployment"
      },
      {
        _id: "configuration",
        name: "Configuration",
        location: "configuration",
        redirectTo: configurationRedirectPath,
        icon: ConfigIcon
      },
      {
        _id: "deploy",
        name: "Deploy",
        location: "deploy",
        redirectTo: deployRedirectPath,
        icon: DeployIcon
      },
    ];
  } else if (selectedApp.type === "a8flow") {
    tabs = [
      {
        type: "Group",
        name: "Workflow"
      },
      {
        _id: "journey",
        name: "Journey",
        location: selectedApp.type === "a8flow" ? "assist" : "solo",
        redirectTo: journeyRedirectpath,
        icon: JourneyIcon
      },
      {
        _id: "services",
        name: "Services",
        location: "service",
        redirectTo: serviceRedirectPath,
        icon: ServicesIcon
      },
      {
        _id: "dmn",
        name: 'DMN',
        location: 'dmn',
        redirectTo: 'assist/dmn/list',
        icon: DmnIcon
      },
      {
        type: "Group",
        name: ""
      },
      {
        _id: "ai-agents",
        name: "AI Agents",
        location: "ai-agents",
        redirectTo: aiAgentPath,
        style: {
          background: "linear-gradient(90deg, #42A0FF 0%, #B56BFF 33.33%, #FF7F56 99.99%, rgba(255, 178, 82, 0) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: 600
        },
        icon: AIAgentIcon
      },
      {
        type: "Group",
        name: "UI & Logic"
      },
      {
        _id: "forms",
        name: "Forms",
        location: "forms",
        redirectTo: formRedirectPath,
        icon: FormIcon
      },
      {
        _id: "functions",
        name: "Functions",
        location: "functions",
        redirectTo: functionRedirectPath,
        icon: FunctionIcon
      },
      {
        _id: "i18n",
        name: "i18n",
        location: "i18n",
        redirectTo: i18nRedirectPath,
        icon: InternationalizationIcon
      },
      {
        _id: "staticAsset",
        name: "Static Asset",
        location: "static-asset",
        redirectTo: staticAssetPath,
        icon: StaticAssetsIcon
      },
      {
        type: "Group",
        name: "Data & Security"
      },
      {
        _id: "data",
        name: "Data",
        location: "data",
        redirectTo: dataRedirectPath,
        icon: DataIcon
      },
      {
        _id: "dataModel",
        name: "Data Model",
        location: "dataModel",
        redirectTo: dataModelRedirectPath,
        icon: DataModelIcon
      },
      {
        _id: "secureVariables",
        name: "Secure Variables",
        location: "secure-variables",
        redirectTo: secureVariableRedirectPath,
        icon: SecureVariablesIcon
      },
      {
        _id: "AclGroup",
        name: "ACL",
        location: "acl",
        redirectTo: "assist/security/acl/list",
        icon: ACLIcon
      },
      {
        type: "Group",
        name: "Deployment"
      },
      {
        _id: "configuration",
        name: "Configuration",
        location: "configuration",
        redirectTo: configurationRedirectPath,
        icon: ConfigIcon
      },
      {
        _id: "deploy",
        name: "Deploy",
        location: "deploy",
        redirectTo: deployRedirectPath,
        icon: DeployIcon
      }
    ];
  }

  const onRedirect = (path: string) => {
    location === "apps" && history.push("/apps/list/" + appId + "/" + path);
    location === "organization" &&
      tabLocation &&
      history.push("/organization/" + currentOrganizationId + "/" + path);
    location === "marketplace" &&
      tabLocation &&
      history.push("/marketplace/" + path);
  };
  const currentAppversion = useSelector((state: any) => {
    return state.apps.appVersion && state.apps.appVersion[appId]
  })
  
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "calc(100vh - 50px)",
          width: 195
        }}
      >
        <div style={{ overflowY: 'auto', overflowX: "hidden", padding: '0px 10px 10px 10px'}}>
          {tabs.map((tab, i) => {
            const isCurrentTab =
            (tab.location === tabLocation ||
              (tabLocation === "security" && locationSplit[6] === tab.location))
              ? true
              : false;
            if (tab.type === "Group" && selectedApp.type === "a8solo" && tab.location === 'conversation') {
              return null
            }
            if (tab.type === "Group") {
              return (
                <>
                  <div style={{ marginTop: i !== 0 ? !tab.name ? 0 : 10 : 15, padding: "5px 10px"}}>
                    <span style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', color: '#052F35'}}>{tab.name}</span>
                  </div>
                  {tab._id === "chat_group" && selectedApp.type === "a8chat" && <SoloChatRoutes chatType={selectedApp.chatType} redirectTo={onRedirect} />}
                </>
              )
            } else return (
              <div
                data-test-id={tab._id + "_tab"}
                key={tab._id}
                onClick={() => {
                    onRedirect(tab.redirectTo);
                }}
                style={{
                  position: "relative",
                  height: securityTabOpen  && tab._id === "security"
                    ? (selectedApp.type === "a8flow"  ? "101px" : "69px") 
                    : "36px",
                  width: "100%",
                  fontSize: "14px",
                  padding: "10px",
                  borderRadius: "6px",
                  background: isCurrentTab ? "#15808C10" : "",
                  cursor: "pointer",
                  fontWeight: 500,
                  color: isCurrentTab ? "#15808C" : "#292D32",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10, ...(tab.style && tab.style) }}>
                  {tab.icon && <tab.icon color={isCurrentTab ? '#15808C':'#292D32'} />} 
                  <span className={`${tab._id ===  'ai-agents' ? style.aiagents : ''}`}>{tab.name}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
export default AppsMenu;
